// extracted by mini-css-extract-plugin
export default {"attachFile":"styles_attachFile__a32f0"};